import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'

import { RequestStatus } from 'clickNgo/configs/service/common'

import { requestApi } from '../features/api/requestApi'
import { selectRequestData } from '../features/selectors/selectRequestData'

export const useRequest = (requestId: string) => {
  const dispatch = useAppDispatch()
  const { data: req, meta, status } = useSelector(selectRequestData)

  useEffect(() => {
    if (!meta || meta.arg?.['requestId'] !== requestId) {
      dispatch(requestApi.getRequestData({ requestId }))
    }
  }, [requestId, dispatch, meta])

  return {
    req,
    reqWip: status === RequestStatus.PENDING,
  }
}
